// Web builds talk to the API on their own origin: every host that serves this app
// — app.streamster.io, beta.streamster.io, wl.streamster.io — proxies /api to its
// own account backend. That makes the build environment-agnostic: the same bundle
// is correct on beta and production, so there is no build-time target to get wrong.
//
// It used to default to the production URL when APP_API_HOST was unset, which meant
// forgetting the variable silently pointed beta at production data instead of
// failing. A relative path cannot do that: if a host lacks the proxy the requests
// return the SPA's HTML and break loudly, which is the failure we want.
//
// The override remains for local development, where the dev server has no proxy
// (see .env.debug).
//
// It must be absolute, not the bare '/api' path: api() prepends an API_LOGIN_URLS
// balancer host to any url that does not start with 'http', so a relative path
// sends login to https://de10.streamster.io:6002//api/authorize (404 on all three
// servers) and surfaces as "No connection". Building it from location.origin keeps
// the bundle environment-agnostic while staying absolute.
export const API_HOST_URL = import.meta.env.APP_API_HOST || `${window.location.origin}/api`;

export const SERVERS = ['de10', 'mi1', 'mo1'];

export const API_BALANCER_URLS = SERVERS.map(s => `https://${s}.streamster.io:6001`);
export const API_LOGIN_URLS = SERVERS.map(s => `https://${s}.streamster.io:6002/`);

export const ADMIN_TOKEN_USER_ID = 4;
export const ADMIN_TOKEN_USER_LOGIN = 'sadmin_user';
